import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificationTemplateTreeViewerComponent } from 'src/app/construct-x/shared/components/certification-template-tree-viewer/certification-template-tree-viewer.component';
import { TemplateNode } from 'src/app/components/product-certification/certifications/certifications/certification-template-editor/certification-template-editor.component';
import { Certificate } from 'src/app/construct-x/wallet/models/certificate';
import { SpanButtonComponent } from 'src/app/construct-x/shared/components/form-elems/span-button/span-button.component';

@Component({
  selector: 'app-cert-details',
  imports: [CommonModule, CertificationTemplateTreeViewerComponent, SpanButtonComponent],
  templateUrl: './cert-details.component.html',
  styleUrl: './cert-details.component.scss',
})
export class CertDetailsComponent {

  @Input() detailType: 'tree' | 'raw';
  @Input() isAuth: boolean;
  @Input() vcTreeData: TemplateNode[];
  @Input() certificate: Certificate;


  toggleViewMode(): void {
    const current = this.detailType || 'tree';
    this.detailType = current === 'tree'? 'raw' : 'tree';
  }

}
